import {SSLAConfiguration} from "./config";
import {CourseTypeDetector} from "./detector";
import {cleanupOnExit} from "./open";

export abstract class SSLAPlugin {
    public config: SSLAConfiguration = null;
    public ctd: CourseTypeDetector = null;
    public checked = false;
    public contents: any;
    abstract closeActiveContent(): void;
    abstract finish(): void;
    abstract getMainAsset(callback: Function): void;
    abstract interstitialReady(): void;
    abstract navigate(type: string): void;
    abstract navigateByIdentifier(id: string): void;
    abstract start(): void;

    cleanup() {
        // Clear the visible contents of the TOC.
        document.getElementById("toc").innerHTML = "";
        // Disable buttons.
        (<HTMLButtonElement>document.getElementById("prev")).disabled = true;
        (<HTMLButtonElement>document.getElementById("next")).disabled = true;
        cleanupOnExit(this.config);
    }
}
